export function getFirstColNameForRussia(analyticsViewAllKey) {
  switch (analyticsViewAllKey?.value) {
    case "country_of_origin":
      return "Country";
    case "country_of_export":
      return "Country";
    case "places_of_receipt":
      return "Port";
    case "producers":
      return "Producers";
    case "hs_code":
      return "HS Code";
    case "six_digit_hs_code":
      return "HS Code";
    case "sections":
      return "Sections";
    case "trade_country_of_origin_to_export_to_destination":
      return "Country of Origin";
    case "country_of_import":
      return "Country";
    case "country_of_destination":
      return "Country";
    case "place_of_delivery":
      return "Port";
    case "shipper_city":
      return "City";
    case "shipper_state":
      return "State";
    case "trade_country_of_origin_to_import_to_destination":
      return "Country of Origin";
    case "trade_country_of_export_to_import":
      return "Country of Export";
    default:
      return "";
  }
}

export function getSecondColNameForRussia(analyticsViewAllKey) {
  switch (analyticsViewAllKey?.value) {
    case "trade_country_of_origin_to_export_to_destination":
      return "Country of Export";
    case "trade_country_of_origin_to_import_to_destination":
      return "Country of Import";
    case "trade_country_of_export_to_import":
      return "Country of Import";
    default:
      return "";
  }
}

export function getThirdColNameForRussia(analyticsViewAllKey) {
  switch (analyticsViewAllKey?.value) {
    case "trade_country_of_origin_to_export_to_destination":
      return "Country of Import";
    case "trade_country_of_origin_to_import_to_destination":
      return "Country of Destination";
    default:
      return "";
  }
}

export const getFirstColNameForUSImports = (analyticsViewAllKey) => {
  const { value, label } = analyticsViewAllKey;
  switch (value) {
    case "derived_trade_lane":
      return "Lading Region";
    case "trade_port_of_lading_to_unlading":
      return "Port of Lading";
    case "trade_country_of_export_to_import":
      return "Country of Export";
    default:
      return label === "Trade Port" ? "Ports of Unlading" : label === "Trade Country" ? "Country of Export" : label;
  }
};

export const getFirstColNameForUSExports = (analyticsViewAllKey) => {
  const { value, label } = analyticsViewAllKey;
  switch (value) {
    case "derived_trade_lane":
      return "Lading Region";
    case "trade_country_of_export_to_import":
      return "Country of Export";
    default:
      return label === "Trade Port" ? "Port of Lading" : label === "Trade Country" ? "Shipper State" : label;
  }
};

export const getSecondColNameForUSImports = (analyticsViewAllKey) => {
  const { value, label } = analyticsViewAllKey;
  switch (value) {
    case "derived_trade_lane":
      return "Unlading Region";
    case "trade_port_of_lading_to_unlading":
      return "Port of Unlading";
    case "trade_country_of_export_to_import":
      return "Country of Import";
    default:
      return label === "Trade Port" ? "Ports of Unlading" : label === "Trade Country" ? "Consignee State" : label;
  }
};

export const getSecondColNameForUSExports = (analyticsViewAllKey) => {
  const { value, label } = analyticsViewAllKey;
  switch (value) {
    case "derived_trade_lane":
      return "Unlading Region";
    case "trade_country_of_export_to_import":
      return "Country of Import";
    default:
      return label === "Trade Port" ? "Port of Unlading" : label === "Trade Country" ? "Country of Import" : label;
  }
};

export const getFirstColNameForMultiCountry = (analyticsViewAllKey) => {
  const { value, label } = analyticsViewAllKey;
  switch (value) {
    case "derived_trade_lane":
      return "Lading Region";
    case "trade_route_lading_to_unlading":
      return "Port of Lading";
    case "trade_country_of_export_to_import":
      return "Country of Export";
    default:
      return label === "Trade Port" ? "Ports of Unlading" : label === "Trade Country" ? "Country of Export" : label;
  }
};
export const getSecondColNameForMultiCountry = (analyticsViewAllKey) => {
  const { value, label } = analyticsViewAllKey;
  switch (value) {
    case "derived_trade_lane":
      return "Lading Region";
    case "trade_route_lading_to_unlading":
      return "Port of Unlading";
    case "trade_country_of_export_to_import":
      return "Country of Import";
    default:
      return label === "Trade Port" ? "Ports of Unlading" : label === "Trade Country" ? "Country of Export" : label;
  }
};
